const getCancellationTransactionLabel = (transaction) => transaction === 'charge'
    ? 'Cancellation Fee'
    : transaction === 'waive'
        ? 'Cancellation Fee - Waived'
        : transaction === 'refund'
            ? 'Refund'
            : 'No Cancellation Fee';
export default getCancellationTransactionLabel;
